module.exports = __webpack_public_path__ + "img/pycharm_installation.23b09878.jpg";